import { create } from "zustand";

const calculateItemsCount = (items = []) =>
  items.reduce((total, item) => total + Number(item.quantity || 0), 0);

const calculateFinalTotal = (items = []) =>
  items.reduce((total, item) => {
    const price = Number(item.final_price || item.subtotal || 0);
    return total + price;
  }, 0);

const normalizeCart = (cart) => {
  if (!cart) return cart;

  const items = Array.isArray(cart.items) ? cart.items : [];

  return {
    ...cart,
    items,
    items_count:
      cart.items_count ?? cart.itemsCount ?? calculateItemsCount(items),
    final_total:
      cart.final_total ?? cart.finalTotal ?? calculateFinalTotal(items),
  };
};

export const useCartStore = create((set, get) => ({
  cart: undefined,

  setCart: (cart) =>
    set({
      cart: normalizeCart(cart),
    }),

  clearCart: () =>
    set({
      cart: {
        items: [],
        items_count: 0,
        subtotal: 0,
        total_discount: 0,
        final_total: 0,
      },
    }),

  updateItemQuantityLocal: (itemId, quantity) =>
    set((state) => {
      if (!state.cart?.items) return state;

      const items = state.cart.items.map((item) => {
        if (item.id !== itemId) return item;

        const unitPrice =
          Number(item.unit_price) ||
          Number(item.price_at_time) -
            (Number(item.discount_at_time || 0) * Number(item.price_at_time || 0)) / 100 ||
          Number(item.product?.final_price) ||
          Number(item.product?.price) ||
          0;

        const nextQuantity = Number(quantity);

        return {
          ...item,
          quantity: nextQuantity,
          final_price: unitPrice ? unitPrice * nextQuantity : item.final_price,
          subtotal: unitPrice ? unitPrice * nextQuantity : item.subtotal,
        };
      });

      return {
        cart: normalizeCart({
          ...state.cart,
          items,
        }),
      };
    }),

  removeItemLocal: (itemId) =>
    set((state) => {
      if (!state.cart?.items) return state;

      const items = state.cart.items.filter((item) => item.id !== itemId);

      return {
        cart: normalizeCart({
          ...state.cart,
          items,
        }),
      };
    }),

  getCartSnapshot: () => get().cart,
}));
